<template>
  <div>
    <BreadCrumd :title="'Formations'" :description="'Liste des formations'" />
    <div class="mt-2 mb-4">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <multiselect
            v-model="selectedHeaders"
            :options="headers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par colonne"
            label="text"
            track-by="text"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Colonnes' : 'Colonne' }}
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-md-6 col-lg-8 text-md-right">
          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router.push({ name: 'rh_formation-create' }).catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouvelle formation
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            :headers="selectedHeaders"
            ref="datatable"
            @onSelect="onSelectRows"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/rh/formation/formation';

export default {
  data() {
    return {
      title: 'Gestion des formations',
      isSelect: false,
      selectedHeaders: [],
      headers: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Intitulé',
          align: 'start',
          sortable: true,
          value: 'intitule',
        },
        {
          text: 'Durée (heures)',
          align: 'start',
          sortable: true,
          value: 'duree',
        },
        {
          text: 'Nbre de places disponibles',
          align: 'start',
          sortable: true,
          value: 'nbre_place',
        },
        {
          text: 'Statut',
          align: 'start',
          sortable: false,
          value: 'statut',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
  },
  methods: {
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.FORMATION, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
